/**
 * app/components/DocumentViewerModal.tsx
 * --------------------------------------
 * What: Modal to preview documents (PDF/images) within the app context.
 * Why: Lets users review receipts or generated reports without leaving the UI.
 */
import React from 'react';
import {
  Modal,
  View,
  TouchableOpacity,
  StyleSheet,
  Platform,
  Text,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
// Only available on native – for web we’ll render an iframe instead
import { WebView } from 'react-native-webview';

interface Props {
  visible: boolean;
  url: string | null;
  onClose: () => void;
}

export default function DocumentViewerModal({ visible, url, onClose }: Props) {
  if (!url) return null;

  return (
    <Modal visible={visible} animationType="slide" transparent>
      <View style={styles.overlay}>
        <View style={styles.container}>
          {/* Header */}
          <View style={styles.header}>
            <Text style={styles.title}>Log My Home</Text>
            <TouchableOpacity onPress={onClose} style={styles.closeBtn}>
              <Ionicons name="close" size={28} />
            </TouchableOpacity>
          </View>

          {/* Body */}
          {Platform.OS === 'web' ? (
            <iframe
              src={url}
              title="legal-document"
              style={{ flex: 1, border: 'none', width: '100%' }}
            />
          ) : (
            <WebView source={{ uri: url }} style={{ flex: 1 }} />
          )}
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: '#0008',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    width: '92%',
    height: '85%',
    backgroundColor: 'white',
    borderRadius: 8,
    overflow: 'hidden',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 12,
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  title: {
    fontSize: 18,
    fontWeight: '600',
  },
  closeBtn: {
    padding: 4,
  },
}); 